import { CSSProperties } from 'react';
import { theme } from '../../theme';

export const cardStatusModalStyles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    zIndex: 1000,
  } as CSSProperties,

  sheet: {
    position: 'relative',
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing.mediumLarge,
    padding: `${theme.spacing.extraLarge}px ${theme.spacing.large}px`,
    backgroundColor: theme.colors.background,
    borderTopLeftRadius: theme.radius.md,
    borderTopRightRadius: theme.radius.md,
    boxShadow: theme.shadows.md,
  } as CSSProperties,

  closeButton: {
    position: 'absolute',
    top: theme.spacing.medium,
    right: theme.spacing.medium,
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    padding: theme.spacing.tiny,
    color: theme.colors.label,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.lg,
    lineHeight: 1,
  } as CSSProperties,

  iconWrapper: {
    marginTop: theme.spacing.large,
  } as CSSProperties,

  title: {
    margin: 0,
    textAlign: 'center',
    color: theme.colors.palette.darkGrey200,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.lg,
    fontWeight: theme.typography.fontWeight.bold,
  } as CSSProperties,

  message: {
    margin: 0,
    textAlign: 'center',
    color: theme.colors.label,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.sm,
    lineHeight: theme.typography.lineHeight.sm,
  } as CSSProperties,

  doneButton: {
    width: '100%',
    boxSizing: 'border-box',
    padding: `${theme.spacing.small}px ${theme.spacing.medium}px`,
    border: 'none',
    borderRadius: theme.radius.md,
    backgroundColor: theme.colors.button.primary,
    color: theme.colors.white,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.bold,
    cursor: 'pointer',
  } as CSSProperties,
};
